module.exports = __webpack_public_path__ + "static/ons-mobile-681c3d3fc233f99d072c49dc16b4d880.jpg";